var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.006,
    viewBox: "0 0 17 17.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attach_18px",
    transform: "translate(0 0.006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 17,
    height: 17,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "attach-outline",
    d: "M162.842,84.135v6.1a1.7,1.7,0,1,0,3.4,0l.005-7.993a2.88,2.88,0,1,0-5.76,0v8.047a4.049,4.049,0,1,0,8.1,0v-7.52",
    transform: "translate(-155.891 -78.616)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment_icon.f61c8ea95eaee4719dc69a143a74795e.svg";
export { ForwardRef as ReactComponent };